<script setup>
import { t } from '../i18n';
import { PANEL } from '../ui';
import { formatMonth } from '../achievements';

// «Вы вернулись» (docs/achievements/SPEC.md, «Проект v2», pause and comeback): shown until answered; «Считать с
// возвращения» moves the start point there, «Не надо» is remembered for this comeback.
defineProps({
  // { date, month, pause_months }
  comeback: {
    type: Object,
    required: true,
  },
  busy: {
    type: Boolean,
    default: false,
  },
  // The answer was not saved
  error: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['accept', 'dismiss']);
</script>

<template>
  <section :class="PANEL">
    <p class="text-[0.9375rem] font-medium text-slate-100 sm:text-sm">
      {{ t('achievements.comebackTitle', { month: formatMonth(comeback.month), months: comeback.pause_months }) }}
    </p>
    <p class="mt-1 text-[0.8125rem] text-slate-400">
      {{ t('achievements.comebackText') }}
    </p>
    <div class="mt-3 flex gap-2">
      <button
        type="button"
        class="h-11 flex-1 rounded-2xl bg-slate-100 px-3 text-[0.9375rem] font-medium text-slate-950 disabled:opacity-40 sm:flex-none sm:rounded-lg sm:text-sm"
        :disabled="busy"
        @click="emit('accept')"
      >
        {{ t('achievements.comebackAccept', { month: formatMonth(comeback.month) }) }}
      </button>
      <button
        type="button"
        class="h-11 rounded-2xl bg-slate-800 px-4 text-[0.9375rem] font-medium text-slate-100 disabled:opacity-40 sm:rounded-lg sm:text-sm"
        :disabled="busy"
        @click="emit('dismiss')"
      >
        {{ t('achievements.comebackDismiss') }}
      </button>
    </div>
    <p
      v-if="error"
      class="mt-2 text-[0.8125rem] text-rose-300"
      role="alert"
    >
      {{ error }}
    </p>
  </section>
</template>
